/**
 * 工作台 / 编辑器 Tab favicon 右下角角标资源
 *
 * 工作台：house 白色线条；编辑器：sparkles 白色线条。
 * 具体合成流程见 `renderProjectFavicon.ts`。
 */
/**
 * 工作台：home，白色线条（stroke-width="2.5"，无填充）。
 * viewBox 裁掉多余留白。
 */
export const WORKBENCH_ICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="1.5 1 21 21.5" fill="none"><path d="M3 10L12 2.5L21 10V21H3V10Z" stroke="currentColor" stroke-width="2.5" stroke-linejoin="round"/><path d="M9 14H15V21H9V14Z" stroke="currentColor" stroke-width="2.5" stroke-linejoin="round"/></svg>`;
/**
 * 编辑器：i-mdi-sparkles（MDI），fill 填充。
 */
export const EDITOR_SPARKLES_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="m19 1l-1.26 2.75L15 5l2.74 1.26L19 9l1.25-2.74L23 5l-2.75-1.25M9 4L6.5 9.5L1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5M19 15l-1.26 2.74L15 19l2.74 1.25L19 23l1.25-2.75L23 19l-2.75-1.26"/></svg>`;
export const BADGE_STYLE = {
    workbench: { fg: '#FFFFFF' },
    editor: { fg: '#FFFFFF' },
};
export function getBadgeSvg(corner) {
    return corner === 'editor' ? EDITOR_SPARKLES_SVG : WORKBENCH_ICON_SVG;
}
